import { UnifiedTransactionDto } from 'src/types';
import { UnifiedAccount } from 'src/api/finconnect/usersApi';

/**
 * 💾 État initial du store Powens.
 * Contient les informations de l’utilisateur, du compte sélectionné,
 * ainsi que les paramètres de pagination et filtres pour les transactions.
 */
export const finconnectInitialState = {
  // 🏦 Accounts
  powensAccounts: [] as UnifiedAccount[],
  // ⚙️ Gestion du compte et des transactions
  selectedGroupId: null as number | null, //connectorId for jedeclare accounts and account id for powens accounts
  selectedGroupSource: null as string | null, // "powens" or "jedeclare"
  transactionsPage: 1,
  transactionsLimit: 50,
  transactionsMinDate: null as string | null,
  transactionsMaxDate: null as string | null,
  selectedTransaction: null as UnifiedTransactionDto | null,
  isFilesDialogOpen: false,
  isLinkModalOpen: false,
  selectedTransactionForLink: null as UnifiedTransactionDto | null,
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type FinconnectState = typeof finconnectInitialState;
